import EngineModule from '../EngineModule';

export default () => EngineModule.all.find(x => x.id === 'oms-basket') || new EngineModule.LogicalEngineModule({
	type: 'logical',
	allowedCustomers: null,
	id: 'oms-basket',
	insertionPath: null,
	generateComponentConfiguration: null,
	dependencies: [],
	async initialize() {
		await app.useBasket();
	}
});
